import { ServiceAgreementModificationRequest, ServiceAgreementV2 } from 'pco-product-service-internal-consumer';
import { serviceAgreementApi } from 'api';

export const sendModificationDataApi = async (
  serviceAgreementId: string,
  modificationData: ServiceAgreementModificationRequest,
): Promise<ServiceAgreementV2> => {
  return await serviceAgreementApi.startServiceAgreementModification({
    serviceAgreementUid: serviceAgreementId,
    serviceAgreementModificationRequest: modificationData,
  });
};
